const emailRule = [
  v => {
    return !!v || "Bitte E-Mail angeben";
  },
  v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
    "E-Mail must be valid"
];

const requiredRule = [v => !!v || "Bitte ausfüllen"];

export { emailRule, requiredRule };
